import React from "react";
import PropTypes from "prop-types";
import AcquireWebComponent from "../../framework/MaterialUI";
import Dialog from "material-ui/Dialog";
import { Row, Col } from "../../framework/Grid/";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";

const linkStyle = {
  color: "#215E9B",
};

class BasicTierUpgradeInform extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      subject: undefined,
      comments: undefined,
      openBasicTierContactForm: false,
      showBasicTierSuccessForm: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.request_assist_successful === true &&
      isUndefined(this.props.request_assist_successful) &&
      this.state.openBasicTierContactForm
    ) {
      this.setState({
        subject: undefined,
        comments: undefined,
        showBasicTierSuccessForm: true,
        openBasicTierContactForm: false,
      });
    }
  }

  btnContactClick(e) {
    e.preventDefault();
    this.setState({
      subject: undefined,
      comments: undefined,
      openBasicTierContactForm: true,
      showBasicTierSuccessForm: false,
    });
  }

  btnSubmitClick(e) {
    e.preventDefault();
    const postData = {
      clientId: this.props.selected_client,
      subject: this.state.subject.trim(),
      comment: this.state.comments.trim(),
      originationPage: this.props.originationPage,
      type: "upgrade",
    };
    this.props.onContactFormSubmit(postData);
  }

  btnGobackClick(e) {
    e.preventDefault();
    this.props.closeDialog();
  }

  render() {
    const actionButtons = [
      this.props.send_assist_request_error && (
        <div
          className="pull-left ml-20 mt-5"
          style={{ fontWeight: "bold", color: "#FF0000" }}
        >
          {this.props.send_assist_request_error}
        </div>
      ),
      <button
        onClick={() => {
          this.setState({ openBasicTierContactForm: false });
          if (this.props.onCancel) {
            this.props.onCancel();
          }
        }}
        className="btn btn-default btn-aa-info mr-10"
      >
        Cancel
      </button>,
      isEmpty(this.state.comments) || isEmpty(this.state.subject) ? (
        <button disabled className="btn btn-default btn-aa-info mr-10">
          Submit
        </button>
      ) : (
        <button
          onClick={this.btnSubmitClick.bind(this)}
          className="btn btn-aa-default mr-10"
        >
          Submit
        </button>
      ),
    ];

    return (
      <div>
        <Dialog
          open={
            this.props.showUpgradeInfoDialog &&
            !this.state.openBasicTierContactForm &&
            !this.state.showBasicTierSuccessForm
          }
          contentStyle={{ width: "450px", maxWidth: "500px" }}
          bodyStyle={{
            border: "none",
            color: "#000",
            fontSize: "13px",
            fontWeight: "bold",
            padding: "20px 20px 10px",
          }}
          actions={[
            <a
              className="btn btn-default btn-aa-info"
              style={{ fontWeight: "bold" }}
              onClick={this.btnGobackClick.bind(this)}
            >
              CANCEL
            </a>,
          ]}
          actionsContainerStyle={{
            textAlign: "center",
            paddingBottom: "20px",
            fontWeight: "bold",
          }}
          style={{ zIndex: "1600", paddingRight: "5%" }}
        >
          {this.props.roleId > 50 ? (
            <div
              style={{
                fontFamily: "Arial",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Your subscription tier does not support this option. Please{" "}
              <a style={linkStyle} onClick={this.btnContactClick.bind(this)}>
                click here
              </a>{" "}
              to contact your client services representative to discuss
              upgrading your account.
            </div>
          ) : (
            <div
              style={{
                fontFamily: "Arial",
                fontSize: "16px",
                lineHeight: "20px",
              }}
            >
              Your subscription tier does not support this option. Please
              contact your client services representative to discuss upgrading
              your account.
            </div>
          )}
        </Dialog>
        <Dialog
          open={this.state.openBasicTierContactForm}
          contentStyle={{ width: "540px" }}
          titleClassName={"support-form-title"}
          bodyClassName={"support-form-body"}
          actionsContainerClassName={"support-form-action-container"}
          title={"CONTACT US"}
          modal={true}
          actions={actionButtons}
        >
          <Row className="no-padding-left no-padding-right no-padding-bottom pt-10 no-margin-bottom">
            <Col xs="3" sm="3" md="3" lg="3" className="pt-10">
              <strong>Subject</strong>
            </Col>
            <Col xs="9" sm="9" md="9" lg="9">
              <input
                type="text"
                style={{ width: "100%" }}
                value={this.state.subject}
                maxLength="65"
                onChange={e => {
                  this.setState({ subject: e.target.value });
                }}
              />
            </Col>
          </Row>
          <Row className="no-padding-left no-padding-right no-padding-bottom no-margin-bottom">
            <Col xs="3" sm="3" md="3" lg="3" className="pt-10">
              <strong>Comments</strong>
            </Col>
            <Col xs="9" sm="9" md="9" lg="9">
              <textarea
                className="comment-box"
                value={this.state.comments}
                maxLength="500"
                onChange={e => {
                  this.setState({ comments: e.target.value });
                }}
              />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.showBasicTierSuccessForm}
          onRequestClose={() => {
            this.setState({ showBasicTierSuccessForm: false });
          }}
          contentStyle={{ width: "350px", padding: "20px" }}
          modal={true}
        >
          <div
            style={{ fontSize: "16px", fontFamily: "Arial", color: "#000" }}
            className="text-center"
          >
            Your message has been sent.
          </div>
          <div
            style={{ fontSize: "15px", fontFamily: "Arial", color: "#000" }}
            className="text-center mt-10"
          >
            Your client services representative will contact you within one
            business day.
          </div>
          <div className="text-center mt-20">
            <a
              className="btn btn-default btn-aa-default"
              onClick={this.btnGobackClick.bind(this)}
            >
              CLOSE
            </a>
          </div>
        </Dialog>
      </div>
    );
  }
}

BasicTierUpgradeInform.propTypes = {
  send_assist_request_error: PropTypes.string,
  showUpgradeInfoDialog: PropTypes.bool,
  onContactFormSubmit: PropTypes.func,
  selected_client: PropTypes.number,
  originationPage: PropTypes.string,
  type: PropTypes.string,
  request_assist_successful: PropTypes.bool,
  roleId: PropTypes.number,
};

BasicTierUpgradeInform.default = {
  showUpgradeInfoDialog: false,
};

export default BasicTierUpgradeInform;



// WEBPACK FOOTER //
// ./src/components/Insights/website/BasicTierUpgradeInform.jsx